import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import { AI_SEARCH_INIT_PROMPT_PARAM } from '@xing-com/crate-jobs-constants';
import type { AIEarnMoreDialogProps } from '@xing-com/crate-jobs-xinglets';

import { useAIEarnMoreDialogSalary, useForceAIEarnMoreQuery } from '../apollo';

/**
 * Extracted hook to keep the container component clean
 */
export const useAIEarnMoreDialogProps = (): AIEarnMoreDialogProps => {
  const { getSearchParameter, deleteSearchParameter } = useSearchParameter();
  const [aiEarnMoreDialogValue, setEarnMoreDialogValue] =
    useAIEarnMoreDialogSalary();
  const [, setForceAIEarnMoreQuery] = useForceAIEarnMoreQuery();

  const onClose = (): void => {
    setEarnMoreDialogValue(null);

    if (getSearchParameter(AI_SEARCH_INIT_PROMPT_PARAM)) {
      deleteSearchParameter(AI_SEARCH_INIT_PROMPT_PARAM);
    }
  };

  const onForceQuery = (): void => {
    setForceAIEarnMoreQuery(true);
  };

  return {
    value: aiEarnMoreDialogValue,
    onClose,
    onForceQuery,
  };
};
